export const GAME_KEYS = {
    SYNAPSE: 'synapseSurfer_highScore',
    FOCUS: 'focusFlyer_highScore',
    PINBALL: 'mindstormPinball_highScore'
};

// Returns the number, defaults to 0 if null
export const getHighScore = (gameKey) => {
    return parseInt(localStorage.getItem(gameKey)) || 0;
};

// Returns TRUE if a new high score was set, FALSE otherwise
export const trySetHighScore = (gameKey, newScore) => {
    const currentHigh = getHighScore(gameKey);
    if (newScore > currentHigh) {
        localStorage.setItem(gameKey, newScore.toString());
        return true;
    }
    return false;
};
